module.exports = __webpack_public_path__ + "static/media/logo-github.8a1ba32d.svg";